// extracted by mini-css-extract-plugin
module.exports = {"s1fzv4xx":"s1fzv4xx"};